import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { captureException, track } from '@turfchale/analytics'
import { supabase } from '@turfchale/supabase'
import { useEffect } from 'react'

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
})

function AuthCallbackPage() {
  const navigate = useNavigate()
  const { redirect: redirectTo } = useSearch({ from: '/auth/callback' })

  useEffect(() => {
    supabase.auth.getSession().then(
      async ({ data: { session } }) => {
        if (!session) {
          navigate({ params: {}, search: { redirect: undefined }, to: '/auth' })
          return
        }

        const [profileRes, memberRes] = await Promise.all([
          supabase.from('profiles').select('role').eq('id', session.user.id).single(),
          supabase
            .from('organization_members')
            .select('id')
            .eq('user_id', session.user.id)
            .maybeSingle(),
        ])

        const isStaff = profileRes.data?.role === 'admin' || memberRes.data !== null

        track('auth_signed_in', { role: profileRes.data?.role ?? 'player' })

        if (isStaff && !redirectTo) {
          navigate({ to: '/auth/staff-redirect' })
        } else {
          navigate({ to: redirectTo ?? '/app' })
        }
      },
      (err) => {
        captureException(err, { context: 'auth_callback_get_session' })
        navigate({ params: {}, search: { redirect: undefined }, to: '/auth' })
      },
    )
  }, [navigate, redirectTo])

  return (
    <div
      style={{
        alignItems: 'center',
        background: 'var(--bg)',
        color: 'var(--muted)',
        display: 'flex',
        fontSize: '15px',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      Signing you in…
    </div>
  )
}
